module.exports = __webpack_public_path__ + "img/stratumblue_white_outline_logo.7b76d9cd.png";